// Mock data for Gabriele Tita's portfolio

export const developerInfo = {
  name: "Gabriele Tita",
  role: "Backend Developer & Cybersecurity Specialist",
  location: "Verona, Italy",
  vat: "VAT ID 04200070235",
  email: "gabriele.tita@gmail.com",
  linkedin: "https://www.linkedin.com/in/gabriele-tita-9493b555/",
  github: "https://github.com/titagram/",
  bio: "Specialized in backend development and cybersecurity. Passionate about building secure, scalable systems and performing web application vulnerability assessments."
};

export const skills = [
  "Laravel",
  "Node.js",
  "Elastic",
  "Docker",
  "Kubernetes",
  "PostgreSQL",
  "MongoDB",
  "Redis",
  "Linux",
  "Vulnerability Assessment",
  "OWASP Top 10",
  "Network Security",
  "Burp Suite",
  "Metasploit",
  "Nmap",
  "Wireshark"
];

export const projects = [
  {
    id: 1,
    name: "mini-SOC",
    description: "A comprehensive Security Operations Center environment built with Docker. Combines intentionally vulnerable web applications (DVWA, WordPress) with industry-standard security monitoring tools including WAF (ModSecurity), IDS (Suricata), and SIEM platforms (ELK Stack & Splunk). Perfect for learning web attack vectors, WAF tuning, and security log analysis.",
    github: "https://github.com/titagram/mini-SOC.git",
    tech: ["Docker", "ModSecurity", "Suricata", "ELK Stack", "Splunk", "DVWA"]
  }
];

export const articles = [
  {
    id: 1,
    title: "Building a SOC Lab with Docker: From Theory to Practice",
    date: "2025-01-02",
    excerpt: "A complete guide to creating a laboratory SOC environment using Docker containers. Configuration of DVWA, ModSecurity WAF, Suricata IDS, and ELK stack for security log analysis.",
    readTime: "15 min read",
    tags: ["Docker", "SOC", "Security Lab"]
  },
  {
    id: 2,
    title: "Web Application Vulnerability Assessment: Methodology and Tools",
    date: "2024-12-28",
    excerpt: "Overview of vulnerability assessment methodologies for web applications, from OWASP Top 10 analysis to the practical use of Burp Suite and other testing tools.",
    readTime: "12 min read",
    tags: ["Vulnerability Assessment", "OWASP", "Web Security"]
  },
  {
    id: 3,
    title: "ModSecurity and OWASP Core Rule Set: Protecting Web Apps",
    date: "2024-12-15",
    excerpt: "Advanced configuration of ModSecurity with OWASP CRS to protect web applications from SQL injection, XSS, and other common attacks. Best practices and rule tuning.",
    readTime: "10 min read",
    tags: ["WAF", "ModSecurity", "OWASP CRS"]
  },
  {
    id: 4,
    title: "Security Log Analysis with ELK Stack and Splunk",
    date: "2024-12-05",
    excerpt: "How to configure effective log collection pipelines with Filebeat, Logstash, and Elasticsearch. Creating dashboards in Kibana and Splunk for threat hunting.",
    readTime: "14 min read",
    tags: ["ELK", "Splunk", "SIEM", "Log Analysis"]
  },
  {
    id: 5,
    title: "Suricata IDS: Network Intrusion Detection",
    date: "2024-11-20",
    excerpt: "Introduction to Suricata as an intrusion detection system. Installation, rule configuration, and integration with SIEM for complete network visibility.",
    readTime: "11 min read",
    tags: ["IDS", "Suricata", "Network Security"]
  }
];

export const asciiArt = {
  logo: `
   ____    _          _      _      _       
  / ___|  | |_       | |    (_)    | |_     
 | |  _   | __|      | |    | |    | __|    
 | |_| |  | |_       | |    | |    | |_     
  \\____|   \\__|      |_|    |_|     \\__|    
                                             
  `,
  
  metasploit: `
                                   
      =[ metasploit v6.3.4-dev                          ]
+ -- --=[ 2345 exploits - 1219 auxiliary - 413 post       ]
+ -- --=[ 1385 payloads - 46 encoders - 11 nops           ]
+ -- --=[ 9 evasion                                       ]
  `,
  
  nmap: `
Starting Nmap 7.94 ( https://nmap.org )
  `,
  
  hydra: `
Hydra v9.5 (c) 2023 by van Hauser/THC
  `,
  
  welcome: `
 ██████╗  █████╗ ██████╗ ██████╗ ██╗███████╗██╗     ███████╗    ████████╗██╗████████╗ █████╗ 
██╔════╝ ██╔══██╗██╔══██╗██╔══██╗██║██╔════╝██║     ██╔════╝    ╚══██╔══╝██║╚══██╔══╝██╔══██╗
██║  ███╗███████║██████╔╝██████╔╝██║█████╗  ██║     █████╗         ██║   ██║   ██║   ███████║
██║   ██║██╔══██║██╔══██╗██╔══██╗██║██╔══╝  ██║     ██╔══╝         ██║   ██║   ██║   ██╔══██║
╚██████╔╝██║  ██║██████╔╝██║  ██║██║███████╗███████╗███████╗       ██║   ██║   ██║   ██║  ██║
 ╚═════╝ ╚═╝  ╚═╝╚═════╝ ╚═╝  ╚═╝╚═╝╚══════╝╚══════╝╚══════╝       ╚═╝   ╚═╝   ╚═╝   ╚═╝  ╚═╝
                                                                                                
         Backend Developer & Cybersecurity Specialist | Verona, Italy
  `,

  welcomeMobile: `
  ██████╗ ████████╗
 ██╔════╝ ╚══██╔══╝
 ██║  ███╗   ██║   
 ██║   ██║   ██║   
 ╚██████╔╝   ██║   
  ╚═════╝    ╚═╝   

 Gabriele Tita
 Backend Developer & Cybersecurity Specialist
 Verona, Italy
  `
};
